<template>
    <div class="md-layout">
            <div class="md-layout-item">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'file']" />
                                </div>
                                <h4 class="title">Liste des rapports d'interventions</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <md-table v-model="reports" table-header-color="blue">
                            <md-table-toolbar>
                                <md-field class="w-1/12">
                                    <label for="pages">Éléments à afficher</label>
                                    <md-select v-model="pagination.perPage" id="pages" name="pages">
                                        <md-option
                                            v-for="item in pagination.perPageOptions"
                                            :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </md-table-toolbar>
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                                <md-table-cell md-label="#"><span>{{ item.id }}</span></md-table-cell>
                                <md-table-cell md-label="Nom"><span>{{ item.intervention.id }}</span></md-table-cell>
                                <md-table-cell md-label="Intervention"><span>{{ getClientName(item) }}</span></md-table-cell>
                                <md-table-cell md-label="Compte rendu"><span> Fiche </span></md-table-cell>
                            </md-table-row>
                        </md-table>
                    </md-card-content>
                    <md-card-actions md-alignment="space-between">
                        <p class="card-category">
                            Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
                        </p>
                        <pagination
                            class="pagination-no-border pagination-info"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="pagination.total"
                            @input="getInterventionReportTypes"
                        >
                        </pagination>
                    </md-card-actions>
                </md-card>
            </div>
        </div>
</template>

<script>
import { Pagination } from "@/components";

export default {
    name: "InterventionReports",
    components: {
        Pagination
    },
    data() {
        return {
            reports: [],
            pagination: {
                perPage: 100,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
        }
    },
    methods: {
        async getInterventionReportTypes() {
            const response = await this.$store.dispatch('interventionReports/getInterventionReports', {
                page: this.pagination.currentPage,
                perPage: this.pagination.perPage,
            })
            this.reports = response.data.data
            this.pagination.total = response.data.total
        },
        getClientName: function(item) {
            let name = item.intervention.site ? item.intervention.site.client.name : ''
            if (!name) {
                name = item.intervention.contract ? item.intervention.contract.site.client.name : ''
            }
            return name
        }

    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.reports.length;
        },
    },
    mounted() {
        this.getInterventionReportTypes()
    }
}
</script>

<style scoped>

</style>
